module.exports = __webpack_public_path__ + "static/paystack-webhook-26411062ec9fad902f6a720f5f10e2b9.png";